// Version : 0.0.5
// LastEdit : KARTHEESWARAN
// MODFIED DATA : 13-08-2025
const PurposeOfLoanTypeActionTypes = {
	/** ***************** GET ALL PURPOSE OF LOAN TYPE DETAILS START *********************** */
	GET_PURPOSE_OF_LOAN_TYPE_START: 'get_purpose_of_loan_type_start',
	GET_PURPOSE_OF_LOAN_TYPE_SUCCESS: 'get_purpose_of_loan_type_success',
	GET_PURPOSE_OF_LOAN_TYPE_FAILURE: 'get_purpose_of_loan_type_failure',
	GET_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET: 'get_purpose_of_loan_type_response_reset',
	GET_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED: 'get_purpose_of_loan_type_response_changed',
	/** ***************** GET ALL PURPOSE OF LOAN TYPE DETAILS END *********************** */

	/** ***************** DELETE PURPOSE OF LOAN TYPE DETAILS START *********************** */
	DELETE_PURPOSE_OF_LOAN_TYPE_START: 'delete_purpose_of_loan_type_start',
	DELETE_PURPOSE_OF_LOAN_TYPE_SUCCESS: 'delete_purpose_of_loan_type_success',
	DELETE_PURPOSE_OF_LOAN_TYPE_FAILURE: 'delete_purpose_of_loan_type_failure',
	DELETE_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET: 'delete_purpose_of_loan_type_response_reset',
	DELETE_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED: 'delete_purpose_of_loan_type_response_changed',
	/** ***************** DELETE PURPOSE OF LOAN TYPE DETAILS END *********************** */

	/** ***************** ADD PURPOSE OF LOAN TYPE DETAILS START *********************** */
	ADD_PURPOSE_OF_LOAN_TYPE_START: 'add_purpose_of_loan_type_start',
	ADD_PURPOSE_OF_LOAN_TYPE_SUCCESS: 'add_purpose_of_loan_type_success',
	ADD_PURPOSE_OF_LOAN_TYPE_FAILURE: 'add_purpose_of_loan_type_failure',
	ADD_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET: 'add_purpose_of_loan_type_response_reset',
	ADD_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED: 'add_purpose_of_loan_type_response_changed',
	/** ***************** ADD PURPOSE OF LOAN TYPE DETAILS END *********************** */

	/** ***************** FETCH PURPOSE OF LOAN TYPE DETAILS START *********************** */
	FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_START: 'fetch_purpose_of_loan_type_details_start',
	FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_SUCCESS: 'fetch_purpose_of_loan_type_details_success',
	FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_FAILURE: 'fetch_purpose_of_loan_type_details_failure',
	FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_RESET:
		'fetch_purpose_of_loan_type_details_response_reset',
	FETCH_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_CHANGED:
		'fetch_purpose_of_loan_type_details_response_changed',
	/** ***************** FETCH PURPOSE OF LOAN TYPE DETAILS END *********************** */

	/** ***************** UPDATE PURPOSE OF LOAN TYPE DETAILS START *********************** */
	UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_START: 'update_purpose_of_loan_type_details_start',
	UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_SUCCESS: 'update_purpose_of_loan_type_details_success',
	UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_FAILURE: 'update_purpose_of_loan_type_details_failure',
	UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_RESET:
		'update_purpose_of_loan_type_details_response_reset',
	UPDATE_PURPOSE_OF_LOAN_TYPE_DETAILS_RESPONSE_CHANGED:
		'update_purpose_of_loan_type_details_response_changed',
	/** ***************** UPDATE PURPOSE OF LOAN TYPE DETAILS END *********************** */
};
export default PurposeOfLoanTypeActionTypes;
